import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
  Container,
  Card,
  CardContent,
} from '@mui/material';
import { LocationOn as LocationOnIcon } from '@mui/icons-material';
import { getLocationOn, setLocationOn as setLocationOnStorage, Colors } from '../../../helpers/navigationHelpers';
import styles from './Location.module.css';

const Location = () => {
  const [locationOn, setLocationOn] = useState(false);

  useEffect(() => {
    setLocationOn(getLocationOn());
  }, []);

  const handleLocationToggle = (event) => {
    const newValue = event.target.checked;
    setLocationOn(newValue);
    setLocationOnStorage(newValue);
    
    // Trigger storage event for other components to update
    window.dispatchEvent(new Event('storage'));
  };

  const primaryColor = locationOn ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;

  return (
    <Container maxWidth="md" className={styles.container}>
      <Box className={styles.header}>
        <LocationOnIcon sx={{ fontSize: 48, color: primaryColor, marginBottom: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Location
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Share your location to find people nearby
        </Typography>
      </Box>

      <Paper elevation={2} className={styles.section}>
        <Box className={styles.toggleSection}>
          <Box>
            <Typography variant="h6" gutterBottom>
              I am on campus?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enable location to see friends and events nearby
            </Typography>
          </Box>
          <Switch
            checked={locationOn}
            onChange={handleLocationToggle}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: primaryColor,
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: primaryColor,
              },
            }}
            size="large"
          />
        </Box>
      </Paper>

      {locationOn ? (
        <Card className={styles.statusCard} sx={{ borderLeft: `4px solid ${primaryColor}` }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ color: primaryColor }}>
              Location Active
            </Typography>
            <Typography variant="body2" color="text.secondary">
              You're visible to friends nearby. Map and nearby users will be available soon.
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Card className={styles.statusCard}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="text.secondary">
              Location Disabled
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enable location to discover friends and events around you.
            </Typography>
          </CardContent>
        </Card>
      )}

      <Box className={styles.mapPlaceholder}>
        <LocationOnIcon sx={{ fontSize: 64, color: '#ccc' }} />
        <Typography variant="h6" color="text.secondary">
          Map View Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Interactive map with nearby users and events
        </Typography>
      </Box>
    </Container>
  );
};

export default Location;

















